import fotoClinica1 from '../assets/images/fotoClinica1.jpeg';
import fotoClinica2 from '../assets/images/fotoClinica2.jpeg';
import fotoClinica3 from '../assets/images/fotoClinica3.jpeg';
import fotoClinica4 from '../assets/images/fotoClinica4.png';
import fotoClinica5 from '../assets/images/fotoClinica5.jpeg';

export const clinicaSlides = [
  { id: 1, image: fotoClinica1 },
  { id: 2, image: fotoClinica2 },
  { id: 3, image: fotoClinica3 },
  { id: 4, image: fotoClinica4 },
  { id: 5, image: fotoClinica5 }
];

export const clinicaTextos = {
  titulo: 'Gerações',
  paragrafos: [
    'Na Clínica Gerações, cuidamos da saúde de forma integral, unindo Medicina Funcional Integrativa, ciência e cuidado humano. Nosso atendimento é personalizado, com foco nas causas dos desequilíbrios, na prevenção e na promoção de vitalidade, longevidade e qualidade de vida.',
    
  ]
};

export const CAROUSEL_INTERVAL = 4000; // 4 segundos
